import Vue from 'vue'
import store from '@/store'
import { createDayjsDate } from '@/utils/dayjs'
import { isInRenewOrderDate, isInRenewOaChatDate, isUpdatedProfile } from '@/utils/order.util'

export default async (to, from, next) => {
  const vm = new Vue()

  const activeLineOfficialAccount = store.getters['User/activeLineOfficialAccount']
  const MAXIMUM_PERIOD_PRE_ORDER = store.getters['SystemConfig/GET_MAXIMUM_PERIOD_PRE_ORDER']

  const isFreePackagePlan = activeLineOfficialAccount.packagePlan === 'free'

  const isRenew = !!to.query.isRenew

  const isBuyPackage = to.params.productType === 'package'
  const isBuyMessage = to.params.productType === 'message'
  const isBuyOaChat = to.params.productType === 'oaChat'
  const isNewLineOfficialAccount = to.params.productType === 'newLineOfficialAccount'

  const minimumRenewDate = vm.$options.filters.dateTimeFormat(
    createDayjsDate(activeLineOfficialAccount.packageExpiredAt)
      .subtract(MAXIMUM_PERIOD_PRE_ORDER.value || 3, MAXIMUM_PERIOD_PRE_ORDER.unit || 'month')
      .set('date', 1)
  )

  if (to.name === 'OrderCreate') {
    if (!isNewLineOfficialAccount && !isUpdatedProfile(activeLineOfficialAccount)) {
      if (to.query.affiliateKey) {
        next({ name: 'LineOfficialAccountCreate' })
      } else {
        await vm.$swal({
          icon: 'warning',
          title: 'ข้อมูล Basic ID ยังไม่ถูกอัพเดท',
          html: 'กรุณาอัพเดทข้อมูล Basic ID ของท่านก่อนทำรายการ',
          confirmButtonText: 'อัพเดทข้อมูล Basic ID'
        })
        next({ name: 'ProfileEdit' })
      }
    } else if (isBuyPackage) {
      let isAllowToBuyPackage = false
      if (
        (isRenew || !isFreePackagePlan)
        && !isInRenewOrderDate(activeLineOfficialAccount, MAXIMUM_PERIOD_PRE_ORDER)
      ) {
        await vm.$swal({
          icon: 'warning',
          title: 'ไม่สามารถซื้อได้',
          html: `คุณยังไม่สามารถซื้อแพ็กเกจล่วงหน้าได้<br>สามารถเริ่มซื้อได้ตั้งแต่วันที่<br>${minimumRenewDate}`
        })
      } else if (
        from.name !== 'OrderSummary'
        && !isRenew
        && isInRenewOrderDate(activeLineOfficialAccount, MAXIMUM_PERIOD_PRE_ORDER)
      ) {
        await vm.$swal({
          icon: 'warning',
          title: 'ไม่สามารถสั่งซื้อได้แพ็กเกจเพิ่มได้',
          html: 'เนื่องจากมีแพ็กเกจอยู่แล้ว<br>หากต้องการต่ออายุ กรุณาสั่งซื้อผ่านปุ่มต่ออายุ'
        })
      } else {
        isAllowToBuyPackage = true
      }

      if (isAllowToBuyPackage) {
        next()
      } else if (!isAllowToBuyPackage && (from.name == null || from.name === 'LineOfficialAccountChoose')) {
        next({ name: 'Home' })
      }
    } else if (isBuyOaChat) {
      let isAllowToBuyOaChat = false
      const hasOaChat = activeLineOfficialAccount.oaChatExpiredAt != null
      if (isRenew && !isInRenewOaChatDate(activeLineOfficialAccount, MAXIMUM_PERIOD_PRE_ORDER)) {
        await vm.$swal({
          icon: 'warning',
          title: 'ไม่สามารถซื้อได้',
          html: `คุณยังไม่สามารถซื้อ OA Chat Package ล่วงหน้าได้<br>สามารถเริ่มซื้อได้ตั้งแต่วันที่<br>${minimumRenewDate}`
        })
      } else if (!isRenew && hasOaChat) {
        await vm.$swal({
          icon: 'warning',
          title: 'ไม่สามารถสั่งซื้อได้ OA Chat Package เพิ่มได้',
          html: 'เนื่องจากมี OA Chat Package อยู่แล้ว หากต้องการต่ออายุ กรุณาสั่งซื้อผ่านปุ่มต่ออายุ'
        })
      } else {
        isAllowToBuyOaChat = true
      }

      if (isAllowToBuyOaChat) {
        next()
      } else if (!isAllowToBuyOaChat && (from.name == null || from.name === 'LineOfficialAccountChoose')) {
        next({ name: 'Home' })
      }
    } else if (isBuyMessage && isFreePackagePlan) {
      vm.$swal({
        icon: 'warning',
        title: 'ไม่สามารถซื้อได้',
        html: 'คุณต้องมีแพ็กเกจเป็น <b>Basic</b> หรือ <b>Pro</b> ก่อนจึงจะสามารถซื้อ Message เพิ่มได้'
      })
    } else {
      next()
    }
  } else {
    next()
  }
}
